import { dataProps, 
        itemListProps } from './properties'

export const setInventoryOrderList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setInventoryOrderRequestList = (state, payload) => {
    state.request_list = payload
}    

export const setInventoryOrderData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    } else if(payload.copy) {
        state.props.item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const setPurchaseOrderShippingAddress = (state, payload) => {
    state.props.shipment_address 
        = payload.legal_name+'\r\n'+payload.address+', \r\n'+payload.city_name+'-'+payload.postal_code+', '
                +payload.province_name+', '+payload.country_name+'.\r\n'
                +payload.contact_number+', '+payload.email_address+'.'
}

export const addNewInventoryOrderItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        if(document.getElementById('item_id_'+(key-1))) {
            document.getElementById('item_id_'+(key-1)).focus()
        }        
    }, 300);

}

export const removeInventoryOrderItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setPOExchangeRate = (state, payload) => {
    state.props.exchange_rate = payload
}

export const resetInventoryOrderData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const togglePruchaseRequestApprovalStatus = (state, payload) => {
    payload.forEach(el => {
        const idIndex = state.request_list.findIndex(t => t.id === el.id)
        if(idIndex>=0) {
            state.request_list[idIndex].approved = el.approved === 1
            state.request_list[idIndex].selected = false
        }
    })
    
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryOrder/mutations.js